import React from "react";

const CommonButton = ({
  type,
  onClick,
  small,
  className,
  lable,
  children,
  disabled,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`fs-6 ${small ? "py-1 " : "py-2"} button shadow ${className}`}
      disabled={disabled}
    >
      {lable ? lable : children}
    </button>
  );
};

export default CommonButton;
